export default __webpack_public_path__ + "static/mob-img08-373d9afbf0d19cb4b2bf12406ffd75ce.png";